// extracted by mini-css-extract-plugin
export default {"NewDeviceCheck":"NewDeviceCheck_NewDeviceCheck__G3Ci9","FieldQuestion":"NewDeviceCheck_FieldQuestion__61ilf","FieldValue":"NewDeviceCheck_FieldValue__EtZAj"};